import { Input, Component, inject } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ApiArticle, ApiOffer, ApiOfferSet, ApiProduction, ApiUser, ApiVOD, ArticlesApi, ProductionsApi } from "@tytapp/api";
import { PageComponent, Transfer } from "@tytapp/common";
import { IMedia } from "./media";

@Component({ template: '' })
export abstract class OfferSetTemplateBase extends PageComponent {
    private htmlSanitizer = inject(DomSanitizer);
    private productionsApi = inject(ProductionsApi);
    private articlesApi = inject(ArticlesApi);

    private _offerSet : ApiOfferSet;

    @Input() user: ApiUser;
    @Input() get offerSet() { return this._offerSet; }
    set offerSet(value) { 
        this._offerSet = value; 
        setTimeout(() => this.onOfferSetUpdated());
    }

    @Input() offer: ApiOffer;
    @Input() step: string;
    @Input() previewing: boolean;

    protected onOfferSetUpdated() {

    }

    get pageComponentId() {
        return 'modern-offers';
    }

    get sanitizedDescription() {
        return this.htmlSanitizer.bypassSecurityTrustHtml(this.offerSet.company_value_props_title);
    }

    get attentionBanner() {
        if (!this.offerSet)
            return '';

        if (this.step === 'pricing')
            return this.offerSet.membership_value_prop_title;
        else if (this.step === 'signup')
            return this.offerSet.profile_prompt_title;
        else if (this.step === 'payment')
            return this.offerSet.payment_prompt_title;
        else
            return this.offerSet.membership_value_prop_title;
    }

    rawOfferUUID: string = undefined;
    offerUUID: string = undefined;
    price: number = undefined;
    get period(): string {
        let offerId = this.rawOfferUUID;
        if (offerId && offerId.startsWith('p:')) {
            let [type, price, period] = offerId.split(/:/);
            return period;
        } else {
            return this.offer ? this.offer.period : null;
        }
    }


    @Transfer()
    production: ApiProduction;

    @Transfer()
    vod: ApiVOD;

    @Transfer()
    article: ApiArticle;

    @Transfer()
    hasFeaturedMedia = false;

    @Transfer()
    media: IMedia;

    backgroundImage = '';
    defaultBackgroundImage = '/assets/join-path/modern_company_value_bg.jpg';

    async init() {
        this.setBackgroundImage();
        this.shell.addPageFlag('payment-flow:modern');

        if (!this.hasServerState) {
            this.hasFeaturedMedia = this.offerSet.featured_media_production_cfid != null || this.offerSet.featured_article_cfid != null;
            if (this.offerSet.featured_media_production_cfid) {
                console.log(`Fetching VOD production...`);
                this.production = await this.productionsApi.get(this.offerSet.featured_media_production_cfid).toPromise();

                for (let episode of this.production.full_length_vods) {
                    (<any><Partial<ApiVOD>>episode).type = 'episode';
                }

                for (let vod of this.production.vod_clips) {
                    (<any><Partial<ApiVOD>>vod).type = 'clip';
                }

                const vodList = [...this.production.full_length_vods, ...this.production.vod_clips];

                for (let vod of vodList) {
                    if (vod.id === this.offerSet.featured_media_vod_cfid) {
                        this.vod = vod;
                        console.log(`Found VOD: `, this.vod);
                    }
                }
                if (this.vod != null) {
                    this.media = {
                        title: this.vod.title,
                        description: this.vod.description,
                        image: this.production.thumbnail_landscape1
                    };
                } else {
                    console.log(`Could not find VOD '${this.offerSet.featured_media_vod_cfid}' in production!`);
                }
            } else if (this.offerSet.featured_article_cfid) {
                this.article = await this.articlesApi.get(this.offerSet.featured_article_cfid).toPromise();

                if (this.article != null) {
                    this.media = {
                        title: this.article.title,
                        description: this.article.subhead,
                        image: this.article.lead_image
                    };
                }
            }
        }

        if (typeof window !== 'undefined') {
            window.addEventListener('resize', () => {
                this.setBackgroundImage();
            });
        }

        this.afterInitialized();
    }

    protected afterInitialized() {

    }

    setBackgroundImage() {
        if (!this.offerSet) {
            return;
        }

        if (typeof window === 'undefined') {
            if (this.offerSet.desktop_image != null) {
                this.backgroundImage = this.offerSet.desktop_image;
            }
        } else {
            if (window.innerWidth <= 1280 && this.offerSet.tablet_image != null) {
                this.backgroundImage = this.offerSet.tablet_image;
            } else if (this.offerSet.desktop_image != null) {
                this.backgroundImage = this.offerSet.desktop_image;
            } else {
                this.backgroundImage = this.defaultBackgroundImage;
            }
        }
    }

    spotIdForMedia(vod: ApiVOD) {
        return `vod_${vod.id}`;
    }
}